import { z } from 'zod/v4'

export const feedbackSchema = z.object({
  analyze_audience: z.boolean(),
  analyze_audience_authenticity: z.boolean(),
  analyze_advertorial: z.boolean(),
  analyze_chrome_extension: z.boolean(),
  analyze_customized_tag: z.boolean(),
})

export type Feedback = z.infer<typeof feedbackSchema>
